class Form {
	constructor(config) {
		this.config = Object.assign({
			scope: 'form'
		}, config);

		this.$scope = $(this.config.scope);

		if(this.$scope.length > 0) {
			this.init();
		}
	}

	init() {
		this.$scope.find('.form-group-submit input').after('<i class="icon-arrow-r"></i>')
	}
}

export default new Form();